import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, HostBinding, input } from '@angular/core';
import { NeoButtonV2Module } from '@neogov/pattern-library/neo-button-v2';
import { NeoLoaderModule } from '@neogov/pattern-library/neo-loader';
import { NEO_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER, NeoTooltipV2 } from '@neogov/pattern-library/neo-tooltip-v2';

export type ButtonVariant = 'flat' | 'stroked' | 'basic';
export type ButtonColor = 'primary' | 'success' | 'danger' | 'gray';
export type ButtonSize = 'sm' | 'm';
export type ButtonIconPosition = 'leading' | 'trailing' | 'none';

@Component({
  selector: 'cm-button',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NeoButtonV2Module, NeoLoaderModule],
  hostDirectives: [{ directive: NeoTooltipV2, inputs: ['neoTooltip: tooltip'] }],
  providers: [NEO_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER],
  templateUrl: './button.component.html',
  styleUrl: './button.component.less',
})
export class ButtonComponent {
  public readonly variant = input<ButtonVariant>('flat');
  public readonly color = input<ButtonColor>('primary');
  public readonly size = input<ButtonSize>('m');
  public readonly disabled = input<boolean>(false);
  public readonly iconOnly = input<boolean>(false);
  public readonly wrap = input<boolean>(false);
  public readonly disableRipple = input<boolean>(false);
  public readonly type = input<'button' | 'submit' | 'reset'>('button');
  public readonly ariaLabel = input<string | undefined>(undefined);
  public readonly ariaBusy = input<boolean | undefined>(undefined);
  public readonly ariaHasPopup = input<string | undefined>(undefined);
  public readonly ariaExpanded = input<boolean | undefined>(undefined);
  public readonly autId = input<string | undefined>(undefined);
  public readonly loading = input<boolean>(false);
  public readonly buttonCssClass = computed(() => `cm-button ${this.color()}`);
  public readonly isDisabled = computed(() => this.disabled() || this.loading());

  @HostBinding('class')
  public get hostBinding(): string {
    return this.isDisabled() ? 'cm-disabled' : '';
  }
}
